var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33184 13.1581L9.16076 11.6591L12.0755 14.5739C13.3247 15.8231 14.9903 16.2395 15.8231 15.8231C16.2395 14.9903 15.8231 13.3247 14.5739 12.0755L11.6592 9.16072L13.1582 2.3318C13.2415 1.9154 13.0749 1.58228 12.7418 1.41572L12.3254 1.16588C11.909 0.999323 11.4926 1.0826 11.2428 1.41572L8.32797 5.82954L5.82958 4.16395V1.66556L4.99678 0.832764L3.33119 3.33115L0.832804 4.99674L1.6656 5.82954H4.16399L5.82958 8.32793L1.41576 11.2427C1.08264 11.4926 0.999363 11.9089 1.16592 12.3253L1.33248 12.7417C1.58232 13.0749 1.91544 13.2414 2.33184 13.1581Z",
    stroke: "#6A7282",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight2);
export default __webpack_public_path__ + "static/media/flight2.c9ab421ed8be8049d8d685ea9783827d.svg";
export { ForwardRef as ReactComponent };